import axios from 'axios';

import { JsonResponse } from 'core/models/response';
import { SelectPlanResponse } from '../models/plans';

export const assignDefaultPlan = async (start_date: string) => {
	try {
		const response = await axios.post<JsonResponse<SelectPlanResponse>>('register/assign-default-free-plan', { start_date });
		return response.data.data;
	} catch (error) {
		throw error;
	}
};
